import $ from 'jquery';
import { track, trackOutbound } from './tracking';
import scrollTo from './scrollTo.js';
import mediumZoom from 'medium-zoom'

$(addHandlers);
$(document).on('vue-loaded', addHandlers);

function addHandlers() {
    const zoom = mediumZoom('[data-zoom]', {
        margin: 24
    });

    NS.scrollTriggerDown = true
    NS.scrollTriggerUp = true;
    NS.nav = $('.navigation');
    NS.imageGalleries = false;

    var windowWidth = $(window).width(),
        navFixed = $('.navigation--fixed').length !== 0,
        $navMenu = $('.navigation__menu-box'),
        $overlay = $('.overlay'),
        $content = $('.content'),
        $footer = $('#main-footer')

    // page does contain image galleries
    if ($('.sub-gallery__list').length > 0) {
        NS.imageGalleries = true;
    }

    // track certain clicks
    $('[data-track]').on('click', function (){
        var data = $(this).data('track').replace(/'/g, '"');
        if (data) {
          var list = JSON.parse(data);
          if (list && list.length >= 3) {
            track(list[0], list[1], list[2]);
          }
        }
    });

    $('[data-trackoutbound]').on('click', function (){
      var data = $(this).data('trackoutbound').replace(/'/g, '"'),
          list = JSON.parse(data);
          track(list[0], list[1], list[2]);

      var href = $(this).attr('href');
      if (href) {
        trackOutbound(href, list[0], list[1], list[2]);
      }
      return false;
    });

    // track certain fbq clicks
    $('[data-fbq]').on('click', function (){
        var data = $(this).data('fbq');
        track('Fbq', data);
    });

    // track focus on inputs
    $('input').on('focus', function () {
        var label = $(this).prev($('label')),
            label = label.text();
        track('Form', 'Focus', label);
    });

    NS.trackOnceIfValue = function (inputId, eventId) {
        var isTracked;
        $(inputId).on('change', function() {
            if (isTracked) return;

            if ($(this).val().length > 0) {
                isTracked = true;
                track('Fbq', eventId);
            }
        });
    }

    // open and close overlay
    NS.openOverlay = function () {
        $('body').addClass('no-scroll');
        NS.nav.addClass('blur');
        $content.addClass('blur');
        $footer.addClass('blur');
        $mobileMenu.addClass('blur');
        $overlay.addClass('overlay--open');
    };

    // Add callbacks for close overlay
    NS.closedOverlayCallbacks = $.Callbacks();

    NS.closeOverlay = function () {
        $('body').removeClass('no-scroll');
        $('.blur').removeClass('blur');
        NS.closeModal('modal--open');

        // specific for image galleries
        if (NS.imageGalleries) {
            $('.overlay--image').css('background-image', 'none');
            $('body').off('keydown.imageGallery');
        }
        $overlay.removeClass('overlay--open');

        // Fire any callbacks
        NS.closedOverlayCallbacks.fire();
    };

    // check if mobile menu is open and close it
    NS.checkAndCloseMobileMenu = function () {
        if ($mobileMenu.hasClass('navigation__mobile-menu--open')) {
            $mobileMenu.removeClass('navigation__mobile-menu--open');
            $navMenu.removeClass('navigation__menu-box--open');
        }
    }

    // open and close modal windows
    NS.openModal = function (which) {
        var $modal = $('.' + which),
            eventLabel = $modal.data('eventLabel');
        $modal.addClass('modal--open');

        // check if height is higher than available view height
        if ($modal.height() >= $(window).height()) {
            $modal.addClass('modal--force-height');
        }

        track('Modal', 'Open', eventLabel);
    };

    NS.closeModal = function (which) {
        var $modal = $('.' + which),
            eventLabel = $modal.data('eventLabel');
        $modal.removeClass('modal--open modal--force-height');
        track('Modal', 'Close', eventLabel);
    };

    NS.scrollTo = function (where) {
        scrollTo(where);
        NS.checkAndCloseMobileMenu();
    }

    NS.scrollToIgnoreTop = function (where) {
        $('html, body').animate({
            scrollTop: (where.offset().top)
        }, 1300);
    }

    // make overlay close-button clickable
    $('.overlay__close, .modal__footer, .modal__close').on('click', function () {
        NS.closeOverlay();
    });




    // page loads with anchor
    if (window.location.hash) {

        // prevent default scroll hack
        setTimeout(function() {
            window.scrollTo(0, 0);

            // scroll to proper position
            var distance = ($('#' + window.location.hash.substr(1)).offset().top - $(window).scrollTop()) - 90;
            $('html, body').scrollTop(distance);
        }, 1);
    }
}